import {
    Card,
    CardHeader,
    CardTitle,
    CardContent,
} from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import Table from "../../../components/table/table-2";
import { columns, data } from "../../../data/admin/role/create-pharmacy";
import { createPharmacyFields } from "../../../config/role/create-pharmacy";
import { isFormValid } from "../../../utils/validators";
import FormRenderer from "../../../components/input-field/form-renderer";
import { useState } from "react";
const CreatePharmacy = () => {

     const [form, setForm] = useState({});

    return (
        <div className="p-2">
            <h2 className="text-xl md:text-2xl text-black font-bold mb-6 md:mb-8">
                Create Pharmacy
            </h2>

            <div className="grid grid-cols-1 gap-8">
                <Card className=" rounded-xl bg-white  border-none ">
                    <div className="w-full p-6 flex flex-col">
                        <div className="w-full">

                            <div className="w-full">
                                <FormRenderer
                                    fields={createPharmacyFields}
                                    values={form}
                                    setValues={setForm}
                                />
                            </div>
                            <div className="mt-3">
                                <Button
                                    disabled={!isFormValid(createPharmacyFields, form)}
                                    variant="admin.secondary">
                                    Summit
                                </Button>
                            </div>
                        </div>
                    </div>

                </Card>

                <Card className="rounded-xl border-none bg-white p-2">
                    <CardHeader>
                        <CardTitle className="text-md md:text-xl text-gray-600">Pharmacy List</CardTitle>
                    </CardHeader>
                    <CardContent className=" text-[#081a3a] text-2xl md:text-4xl font-bold">
                        <Table columns={columns} data={data} rowsPerPage={4} headerBg="bg-[#0a1f44]" headerText="text-white" />
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default CreatePharmacy;
